// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Справи» (Cases, ключ `case`, група `basic`). */
export const casesManifest: IModuleManifest = {
  key: 'case',
  group: 'basic',
  slug: 'cases',
  prefix: 'CASE',
  name: { en: 'Cases', uk: 'Справи' },
  entities: [
    { key: 'case', slug: 'case', name: { en: 'Cases', uk: 'Справи' }, main: true },
    { key: 'case_member', slug: 'case-member', name: { en: 'Case Members', uk: 'Учасники' }, main: false },
    { key: 'case_evidence', slug: 'case-evidence', name: { en: 'Case Evidences', uk: 'Докази' }, main: false },
    { key: 'case_activity', slug: 'case-activity', name: { en: 'Case Activities', uk: 'Дії' }, main: false },
    { key: 'case_deadline', slug: 'case-deadline', name: { en: 'Case Deadlines', uk: 'Строки' }, main: false },
    { key: 'case_status', slug: 'case-status', name: { en: 'Case Statuses', uk: 'Статуси' }, main: false },
    { key: 'case_type', slug: 'case-type', name: { en: 'Case Types', uk: 'Типи справ' }, main: false },
    { key: 'case_area', slug: 'case-area', name: { en: 'Areas of responsibility', uk: 'Сфери відповідальності' }, main: false },
    { key: 'case_issue', slug: 'case-issue', name: { en: 'Issues', uk: 'Проблеми' }, main: false },
  ],
  loadState: () => import('./state/casesSlice').then((m) => m.casesSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
